import React from 'react'
import ButtonSmallIcon from '../../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon';
import useNavigationApp from '../../../../../../navigation/useNavigationApp';
import { useSingleWallet } from '../../../../hooks/useWallet';
import { useAuth } from '../../../../../auth/hooks';
import { userRoles } from '../../../../../user/types/user.types';

export default function WalletsActionBtnPresenter() {
    const navigation = useNavigationApp();
    const { userRole } = useAuth();
    const {singleWalletQuery:{data: walletData}} = useSingleWallet();
    
    const isSuperAdmin = userRole === userRoles.SUPER_ADMIN;
    
  return (
    <WalletActionBtnView
    
    handleAddCredit={ walletData ? () => {
        navigation.goAddCreditWallet(walletData.wallet_user_orga_id, walletData.wallet_id);
    }: undefined}
    
    handleAddManualCredit={ walletData && isSuperAdmin ? () => {
        navigation.goAddManualCreditWallet(walletData.wallet_user_orga_id, walletData.wallet_id);
    }: undefined}

    handleVerifyPayment={ walletData ? () => {
        navigation.goVerifyPaymentWallet(walletData.wallet_user_orga_id, walletData.wallet_id);
    }: undefined}
    />
  )
}

export interface WalletActionBtnProps {
    handleAddCredit?: () => void;
    handleAddManualCredit?: () => void;
    handleCreateNewPaygo?: () => void;
    handleVerifyPayment?: () => void;
}

export const WalletActionBtnView = ({handleAddCredit, handleAddManualCredit, handleCreateNewPaygo, handleVerifyPayment} : WalletActionBtnProps) => {


    return(
        <div style={{display: "flex", gap: "10px", justifyContent: "center", alignItems: "center"}}>
            <div >
            <ButtonSmallIcon
                iconType="plus"
                label="Ajouter du crédit PayGo"
                variant="stack-rounded-icon"
                onClick={handleAddCredit || (() => {})}
                color='rgb(49, 49, 49)'
                iconSize={13}

            />
            </div>
            {handleAddManualCredit && (
            <div >
            <ButtonSmallIcon
                iconType="edit-sheet"
                label="Ajouter crédit manuel"
                variant="stack-rounded-icon"
                onClick={handleAddManualCredit}
                color='rgb(49, 49, 49)'
                iconSize={13}

            />
            </div>
            )}
            {handleVerifyPayment && (
            <div >
            <ButtonSmallIcon
                iconType="search"
                label="Vérifier paiement"
                variant="stack-rounded-icon"
                onClick={handleVerifyPayment}
                color='rgb(49, 49, 49)'
                iconSize={13}

            />
            </div>
            )}
            {/*
            <div >
            <ButtonSmallIcon
                iconType="coin"
                label="Créer un PayGo"
                variant="stack-rounded-icon"
                onClick={handleAddCredit || (() => {})}
                colorBackground="#A6E0EF"
                color='#0A7D9D'
            />
            </div>
            */}
        </div>
    )
}
